
import SystemCode from "@/store/modules/system/customersystemcode/entity";
import { Component, Mixins, ActionButtonConfig, FormModalMixins,appConst} from "@/lib";
import {systemConst} from '@/lib/consts/modules/system'

@Component
export default class CreateSystemCode extends Mixins(FormModalMixins) {
    model: SystemCode = new SystemCode();
    created(){
        Object.assign(this.config, {modelTitleL: "Action.Add",labelWidth:130, okAction:"system/customersystemcode/create", width:660});
    }

    
    
    
    resetModel(){
       this.model = new SystemCode();
    }
      get categoryList() {
         return this.systemCodeWithNoCategory(
      appConst.codeCategory.category
    )}
}
